import type { ReactNode } from 'react';
import { useTranslation } from 'react-i18next';

import { MarkTile, ThemeToggle } from '@/shared/ui';

import styles from './AuthLayout.module.css';

interface AuthLayoutProps {
  title: string;
  subtitle: string;
  children: ReactNode;
  footer?: ReactNode;
}

/**
 * Wspólna oprawa ekranów logowania i rejestracji.
 *
 * Przełącznik motywu jest dostępny PRZED zalogowaniem celowo: to pierwszy ekran,
 * jaki ktokolwiek widzi, a osoba pracująca w ciemnym motywie nie powinna dostać
 * jasnego rozbłysku tylko dlatego, że jeszcze się nie przedstawiła.
 */
export function AuthLayout({ title, subtitle, children, footer }: AuthLayoutProps) {
  const { t } = useTranslation();

  return (
    <main className={styles['page']}>
      <div className={styles['card']}>
        <div className={styles['brand']}>
          <MarkTile size={32} />
          <span className={styles['name']}>{t('app.brand')}</span>
          <span className={styles['spacer']} />
          <ThemeToggle />
        </div>

        <h1 className={styles['title']}>{title}</h1>
        <p className={styles['subtitle']}>{subtitle}</p>

        {children}

        {footer ? <div className={styles['footer']}>{footer}</div> : null}
      </div>
    </main>
  );
}
